export const OpenAIAPIKey = process.env.REACT_APP_OPENAI_API_KEY;